/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';

export const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: TwTheme.values.backgroundColors.componentGray,
    width: 65,
    height: '100%',
    borderRightWidth: 1,
    borderRightColor: '#ECECEC'
  },
  itemWrap: {
    height: 53,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  itemWrap__active: {
    backgroundColor: TwTheme.values.colors.white
  },
  itemLabel: {},
  itemLabel_active: {
    color: TwTheme.values.primaryColors.base
  },
  icon: {},
  dragActiveItem: {
    backgroundColor: TwTheme.values.itemColors.activeBg
  },
  dragItemPlaceholder: {
    flex: 1,
    backgroundColor: TwTheme.values.itemColors.activeBg
  },
  dragItemPlaceholder__disabled: {
    flex: 1,
    backgroundColor: TwTheme.values.errorColors.hover
  }
});
